import { Selection } from "d3-selection";

import { Padding, Size } from "../types";

export function renderSideBars(
  svg: Selection<SVGSVGElement, unknown, null, undefined>,
  size: Size,
  padding: Padding,
) {
  const sideBars = svg.select("g.sideBars");
  const height = Math.max(0, size.height - padding.top - padding.bottom);

  sideBars
    .select("rect.right")
    .attr("x", size.width - padding.right)
    .attr("y", padding.top)
    .attr("width", padding.right)
    .attr("height", height);

  sideBars
    .select("rect.left")
    .attr("x", 0)
    .attr("y", padding.top)
    .attr("width", padding.left)
    .attr("height", height);
}
